// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IconArrowThinLeft = function IconArrowThinLeft (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","transform":"scale(.7)"},"child":[{"tag":"title","attr":{}},{"tag":"path","attr":{"d":"M17,2.30926389e-14 L18.002,0.997 L7,12 L18.001,23 L18,23 L17.002,23.996 L7.406,14.401 L7.40116377,14.4069826 L5,12 L7.40116377,9.59301739 L7.407,9.599 L17,2.30926389e-14 Z"}}]})(props);
};
